import styled from '@emotion/styled';

/**
 * @param {reviewer} 응답자(리뷰어) 객체
 * @param {comment} 리뷰어가 작성한 답변(코멘트)
 * @returns 리뷰 결과 조회시 응답자(리뷰어) 답변(코멘트) 뷰
 */
function ReviewAnswerComment({ reviewer, comment, style }) {
    if (!reviewer?.name?.trim()) {
        reviewer.name = "익명"
    }
    return (
        <Wrap col style={style}>
            <div id="comment">
                <Wrap row gap={"12px"}>
                    <UserImg
                        src={process.env.REACT_APP_RES_PATH + reviewer.profile_image_url}
                        alt="Knotter 이미지!"
                        onError={e => {
                            e.currentTarget.onerror = null
                            e.currentTarget.src = "/image/icn_profile_image_default.svg"
                        }}
                    />
                    <Wrap col gap={"4px"}>
                        <span id="reviewer-name">{reviewer.name}</span>
                        {comment || <span id="empty">-</span>}
                    </Wrap>
                </Wrap>
            </div>
        </Wrap>
    )
}

const Wrap = styled.div`
    display: flex;
    width: 100%;

    #comment {
        color: var(--dark-color);
        font-size: 15px;
        line-height: 1.5em;
        letter-spacing: 0.025em;
        white-space: pre-wrap;
    }
    #reviewer-name {
        color: var(--text-color);
        font-family: 'Gotham';
        font-size: 16px;
        margin-top: 6px;
        line-height: 1em;
        letter-spacing: -0.03em;
    }
    #empty {
        margin-left: 10px;
    }

    ${(props) => props.col && `flex-direction: column;`}
    ${(props) => props.row && `flex-direction: row;`}
    ${(props) => props.gap && `gap: ${props.gap}`}
`;

const UserImg = styled.img`
    width: 56px;
    height: 56px;
    aspect-ratio: 1/1;
    border-radius: 28px;
    object-fit: cover;
`

export default ReviewAnswerComment